import { Injectable } from '@angular/core';
import { WarehouseStateSnapshotMeta, WarehouseStateSnapshotPayload } from './warehouse-state-snapshot.dto';

/**
 * No Idb implementation by design: historical snapshots are lazily
 * loaded on demand and never persisted offline (see Story-9).
 */
@Injectable()
export abstract class SnapshotService {
  abstract listSnapshots(divisionId: string): Promise<WarehouseStateSnapshotMeta[]>;
  abstract getSnapshotMeta(snapshotId: string): Promise<WarehouseStateSnapshotMeta>;
  abstract getSnapshotPayload(snapshotId: string): Promise<WarehouseStateSnapshotPayload>;
}
